import styled, { css } from 'styled-components'

import { Rect } from 'modules/shares/types'

const Highlight = styled.div<{ frame: Rect }>(
  ({ theme, frame }) => css`
    position: absolute;
    top: ${frame.y}px;
    left: ${frame.x}px;
    width: ${frame.width}px;
    height: ${frame.height}px;
    border: 2px solid ${theme.colors.inspect.guide};
    pointer-events: none;
    z-index: 1;
  `
)

export default Highlight
